// @flow
import React from 'react'
import content from 'pp-react-l10n'
import PaymentTypeChoice from './payment-type-choice'
import T3MoneyPage from './alt-payment-type-choice/t3-money-overpanel'
import TparallelButtonOverpanel from './alt-payment-type-choice/tParallelButtonsOverpanel'
import Overpanel from 'react-components/overpanel'
import { connect } from 'transfer/utils/p2p-connect'
import {
  togglePaymentTypeChoiceOverpanel,
  updateTransactionData,
} from 'transfer/actions/unified-actions'
import { getFlowType } from 'transfer/utils/url-utils'
import { PAYMENT_TYPE, MONEY_PAGE } from '../../../../../../lib/constants'
import { trackCancelBtn } from '../../../utils/unified-send-analytics'
import * as SendActions from '../../../actions/send'
import * as PayRequestActions from '../../../actions/pay-request'
// T12-T13 Variants
import PaymentTypeChoiceSelector from './T1213'
import { tracking } from '../../../../lib/analytics/mParticle'
import Events from '../../../../lib/analytics/eventTags'
import * as OverpanelActions from '../../../actions/overpanels'

const i18nPaymentType = content('transfer/inc/paymentTypeChoices')

const paymentTypeUrlMap = {
  [PAYMENT_TYPE.PERSONAL]: '/homepage/send/preview',
  [PAYMENT_TYPE.PURCHASE]: '/homepage/buy/preview',
  send: '/homepage/send/preview',
  buy: '/homepage/buy/preview',
}

type Props = Overpanel & {
  flowType?: string,
  handleCloseForOtherFlow?: () => {},
  isGuest?: boolean,
  purchaseToPersonalTransactionPanelVisibility: boolean,
}

function PaymentTypeChoiceOverpanel({
  show = false,
  handleClose,
  onClosed,
  overpanelType,
  flowType,
  selectedFundingOption,
  receiverFee,
  isAmountValid,
  currencyCode,
  triggerSenderPhoneConfirmation,
  isDCSendMoneyRequest,
  dispatch,
  purchaseToPersonalTransactionPanelVisibility,
  ...rest
}: Props) {
  let Choice

  switch (overpanelType) {
    case MONEY_PAGE.PANEL_TRUST_WEB:
      Choice = T3MoneyPage
      break

    case MONEY_PAGE.TWO_BUTTON_REC_DEFAULT_WEB: // t9
    case MONEY_PAGE.BUYER_FEES_REC_DEFAULT_WEB: // t10
    case MONEY_PAGE.TWO_BUTTON_NON_DEFAULT_WEB: // t11
      Choice = TparallelButtonOverpanel
      break
    case MONEY_PAGE.CTRL_CONTENT_V2_WEB: // T12
      Choice = props => <PaymentTypeChoiceSelector {...props} variant="T12" />
      break
    case MONEY_PAGE.CTRL_VENMO_CONTENT_MESSAGE_WEB: // T14
      Choice = props => (
        <PaymentTypeChoiceSelector
          {...props}
          variant="T12"
          showMessage={true}
        />
      )
      break
    case MONEY_PAGE.CTRL_CONTENT_V2_ORDER_WEB: // T13
      Choice = props => <PaymentTypeChoiceSelector {...props} variant="T13" />
      break
    default:
      Choice = PaymentTypeChoice
  }

  const handleTrackingOverPanelCloseEvent = () =>
    purchaseToPersonalTransactionPanelVisibility
      ? tracking(Events.p2p_protection_overpanel_dismissed())
      : trackCancelBtn()

  return (
    <Overpanel
      show={show}
      handleClose={() => {
        handleClose()
        handleTrackingOverPanelCloseEvent()
      }}
      a11yTitle={i18nPaymentType('main.title')}
      onClosed={onClosed}
    >
      <Choice
        handleClose={handleClose}
        hasSelectedFundingOption={!!selectedFundingOption.id}
        flowType={flowType}
        fee={receiverFee}
        currencyCode={currencyCode}
        {...rest}
      />
    </Overpanel>
  )
}

/**
 * Payment type choice overpanel: goods and service or friends and family
 */
export default connect(
  ({ overpanels, recipient, transaction, amount }) => ({
    show:
      overpanels.paymentTypeChoice ||
      overpanels.purchaseToPersonalTransactionPanelVisibility,
    purchaseToPersonalTransactionPanelVisibility:
      overpanels.purchaseToPersonalTransactionPanelVisibility,
    overpanelType: recipient.moneyPageOverPanel,
    flowType: getFlowType(),
    selectedFundingOption: transaction.selectedFundingOption || {},
    receiverFee: amount.receiverFee,
    currencyCode: amount.currencyCode,
  }),
  (dispatch, ownProps) => ({
    handleClose: (shouldUpdateTransactionData = false, { isPurchase } = {}) => {
      if (shouldUpdateTransactionData) {
        dispatch(updateTransactionData({ isPurchase }))
        // Fetch Funding Options here if user not yet choose payment type
        // So user lands to preview page directly after the payment type is selected
        // Do not fetch funding options if its phone confirmation flow
        if (
          !ownProps.isDCSendMoneyRequest &&
          !ownProps.flowType &&
          ownProps.isAmountValid &&
          !ownProps.triggerSenderPhoneConfirmation
        ) {
          dispatch(SendActions.fetchFundingOptions())
        }

        if (
          ownProps.flowType === 'payRequest' &&
          !ownProps.paymentTypeIsSelected &&
          ownProps.isAmountValid &&
          !ownProps.triggerSenderPhoneConfirmation
        ) {
          dispatch(PayRequestActions.fetchFundingOptions())
        }
      }
      dispatch(
        OverpanelActions.setPurchaseToPersonalTransactionPanelVisibility(false)
      )
      dispatch(togglePaymentTypeChoiceOverpanel({ show: false }))
    },
  })
)(PaymentTypeChoiceOverpanel)

export { paymentTypeUrlMap, PaymentTypeChoiceOverpanel }
